import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "invoice",
    initialState: null,
    reducers: {
        set: (state, action) => action.payload,
    },
});
